import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { jwtDecode } from 'jwt-decode';
import type { TokenUser } from '~/types/Auth';

export const datadogInit = ({ userToken }: { userToken: string | null }) => {
  const config = {
    version: import.meta.env?.APP_VERSION,
    clientToken: 'pubadb7e34f625ebec7d87fd68f20076479',
    site: 'us3.datadoghq.com',
    service: 'supplier-portal',
    env: process.env.NODE_ENV,
    sessionSampleRate: 100,
  };

  if (!datadogRum.getInternalContext()) {
    datadogRum.init({
      ...config,
      applicationId: '5d32d845-69ba-4dfc-8669-867820b4571d',
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });

    if (userToken) {
      const user = jwtDecode<TokenUser>(userToken);

      datadogRum.setUser({
        id: user.sub,
      });
    }
  }

  if (!datadogLogs.getInitConfiguration()) {
    datadogLogs.init({
      ...config,
      forwardErrorsToLogs: true,
    });

    if (userToken) {
      const user = jwtDecode<TokenUser>(userToken);

      datadogLogs.setUser({
        id: user.sub,
      });
    }
  }
};
